// src/components/CodeCountdown.js
import { useEffect, useRef, useState } from "react";

export default function CodeCountdown({
    durationInSeconds = 3600,
    storageKey = "resetCodeExpiresAt",
    onExpire,
}) {
    const expiresAtRef = useRef(null);

    if (expiresAtRef.current === null) {
        const stored = localStorage.getItem(storageKey);
        const now = Date.now();

        if (stored && Number(stored) > now) {
            expiresAtRef.current = Number(stored);
        } else {
            expiresAtRef.current = now + durationInSeconds * 1000;
            localStorage.setItem(storageKey, String(expiresAtRef.current));
        }
    }

    const calcSecondsLeft = () =>
        Math.max(0, Math.round((expiresAtRef.current - Date.now()) / 1000));

    const [secondsLeft, setSecondsLeft] = useState(calcSecondsLeft());

    useEffect(() => {
        if (secondsLeft <= 0) {
            localStorage.removeItem(storageKey);
            onExpire?.();
            return;
        }

        const timer = setInterval(() => {
            setSecondsLeft(calcSecondsLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [secondsLeft]);

    const minutes = Math.floor(secondsLeft / 60);
    const seconds = secondsLeft % 60;
    const formatted = `${minutes}:${seconds.toString().padStart(2, "0")}`;

    const isExpiringSoon = secondsLeft <= 60;
    const isExpired = secondsLeft <= 0;

    return (
        <p
            style={{
                textAlign: "center",
                fontSize: "0.9rem",
                color: isExpired ? "#999" : isExpiringSoon ? "#d32f2f" : "#555",
                marginTop: "0.5rem",
            }}
        >
            {isExpired
                ? "Der Code ist abgelaufen. Bitte fordern Sie einen neuen an."
                : `Code läuft ab in: ${formatted}`}
        </p>
    );
}